// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './common';
export * from './company';
export * from './form';
export * from './layout';
export * from './user';
// @endindex